// to do consider making an enum for it
export const getDwellings = () => ([
    'condominium',
    'living with parents',
    'lodger',
    'own house',
    'rental'
]);
